import constant from '../constants/nameParts.json'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

export function Footer() {

	return (
		<footer>
			<hr/>
			<Container>
        		<Row>
					<Col sm={2}></Col>
					<Col>
						<p>For Tara, the fiercest of warriors.<br/>In memory of Koré, the bestest of kitties.</p>
					</Col>
					<Col sm={2}></Col>
				</Row>
			</Container>
		</footer>
	)	
}

